import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { logoutUser } from '../../actions/userActions';

import FlatButton from 'material-ui/FlatButton';

class NotAllowed extends Component {
  state = {  }
  _handleLogout = (event) => {
    this.props.logoutUser()
  }
  render() {
    return (
      <div 
        style={{ 
          display: 'flex', 
          height: '100vh', 
          width: '100%', 
          alignItems: 'center', 
          justifyContent: 'center',
          flexDirection: 'column',
          backgroundColor: '#d81c1c' 
        }}
      >
        <h1 
          style={{
            color: 'white',
            fontSize: 32,
            fontWeight: '600'
          }}
        >Not Authorized!</h1>
        <div style={{padding: '6px'}}>
          <FlatButton backgroundColor="white" hoverColor="#dfdfdf" onTouchTap={this._handleLogout}>Logout</FlatButton>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({  });
const mapDispatchToProps = { logoutUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotAllowed));



// WEBPACK FOOTER //
// ./src/components/Auth/NotAllowed.js